'use strict';

var cov_1atc947l3d = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userBadge/userBadge.js',
        hash = '924761c6bc5afb07a7f3378d1393c696c076d964',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userBadge/userBadge.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 9,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1atc947l3d.s[0]++;
angular.module('app').component('userBadge', {
    templateUrl: 'app/components/userBadge/userBadge.html',
    bindings: {
        user: '<',
        imgSize: '<'
    }
});